import ReactDOM from "react-dom";
import preloaded from "../../src/preloaded.js";
import TeamRosterContainer from "../../src/availability/2022/TeamRosterContainer.js";
const target = document.getElementById("app");
ReactDOM.render(
  <TeamRosterContainer
    sourceUrl={preloaded.availability_url}
    admin={preloaded.event_admin}
    user_children={preloaded.user_children}
    loggedInUser={preloaded.current_member}
  />,
target);